import { usePusher } from "@harelpls/use-pusher";
import { App, notification } from "antd";
import { FC, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  getEntriesFromSessionStorage,
  removeEntryFromSessionStorage,
} from "utils/manage.session.storage";
import { useCompanyFileMetadataQuery } from "graphql/company/file/get.company.file.metadata.query";

export const CompanyFileDownloader: FC = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const pusher = usePusher();
  const { refetch } = useCompanyFileMetadataQuery({
    skip: true,
    variables: {
      id: "",
    },
  });

  useEffect(() => {
    const checker = setInterval(() => {
      const fileIds = getEntriesFromSessionStorage<string>("generated-exports");

      fileIds.forEach((id) => {
        void refetch({
          id,
        })
          .then(({ data: { data } }) => {
            removeEntryFromSessionStorage("generated-exports", id);

            const link = document.createElement("a");
            link.target = "_blank";
            link.href = data.url;
            link.download = data.name;
            link.click();

            void notification.success({
              duration: null,
              message: t(
                "company-file-export-success",
                'Downloading export of "{value}"',
                { value: data.name },
              ),
              placement: "topRight",
            });
          })
          .catch((error) => {
            // ignore! we do not know how long this might take
          });
      });

      // check status for file ids
    }, 30_000);

    return () => clearInterval(checker);
  }, []);

  const cb = useCallback(
    (event, data) => {
      const fileIds = getEntriesFromSessionStorage<string>("generated-exports");
      if (!fileIds.includes(data.file)) {
        return;
      }

      removeEntryFromSessionStorage("generated-exports", data.file);

      switch (event) {
        case "company-file-export-generated":
          const link = document.createElement("a");
          link.target = "_blank";
          link.href = data.url;
          link.download = data.name;
          link.click();

          void message.destroy(event.file);

          void notification.success({
            duration: null,
            message: t(
              "company-file-export-success",
              'Downloading export of "{value}"',
              { value: data.name },
            ),
            placement: "topRight",
          });
          break;

        case "company-file-export-error":
          void message.destroy(event.file);

          void notification.error({
            duration: null,
            message: t(
              "company-file-export-error",
              'There was an error exporting "{value}"',
              { value: data.name },
            ),
            placement: "topLeft",
          });
          break;

        default:
      }
    },
    [t],
  );

  useEffect(() => {
    if (!pusher.client) {
      return;
    }

    pusher.client.user.bind_global(cb);

    return () => {
      pusher.client.user.unbind_global(cb);
    };
  }, [pusher.client, cb]);

  return null;
};
